import { render, staticRenderFns } from "./print-items-step1.vue?vue&type=template&id=5f2e3e6a&scoped=true&"
import script from "./print-items-step1.vue?vue&type=script&lang=js&"
export * from "./print-items-step1.vue?vue&type=script&lang=js&"
import style0 from "./print-items-step1.vue?vue&type=style&index=0&id=5f2e3e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e3e6a",
  null
  
)

/* custom blocks */
import block0 from "./locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fgitlab-runner%2Fbuilds%2F7624f89f%2F0%2Ftokyo-auction%2Ftokyo-auction-frontend%2Fsrc%2Fcomponents%2Fauction%2Fprint-items-step1.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports